import Box from '@mui/material/Box';
import React from 'react';


const sx = {
    root: {
        position: 'absolute',
        top: '4px',
        right: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '19px',
        height: '13px',
        borderRadius: '2px',
        backgroundColor: '#fff',
        color: '#000',
        fontSize: '7px',
        fontWeight: 700,
        lineHeight: 1,
        '&.new': {
            backgroundColor: 'red',
            color: '#fff'
        }
    }
}

interface IProps {
    variant?: 'old' | 'new'
}

const NavigateIconStatus = ({variant}: IProps) => {
    return (
        <Box
            sx={sx.root}
            className={variant}
        >
            {variant.toUpperCase()}
        </Box>
    );
};

export default NavigateIconStatus;
